/**
 * Fanar basemap: our own monochrome style over OpenFreeMap's vector tiles.
 *
 * Authored rather than borrowed:
 *  1. Their dark style carries 47 layers plus a Natural Earth raster source we do
 *     not need. Drawing fewer things is the whole design goal in drive mode.
 *  2. The palette must be exactly ours — ground #0A0A0A, roads capped at #6E6E6E —
 *     so hazard pins stay the ONLY pure white on screen.
 *  3. One vector source is one dependency, swappable in an afternoon if
 *     OpenFreeMap (single maintainer, no SLA) ever disappears.
 *
 * It ships as a static JSON asset rather than an inline object for two reasons:
 * it is edge-cacheable and offline-cacheable like any other file, and MapLibre
 * 5.24 does not reliably accept an inline style object (the map is left with no
 * style at all, silently, and never requests a tile). A URL always works.
 */
export const STYLE_URL = "/style.json";

/** Layers whose visibility is driven by speed — above 20 km/h the map is not
 *  something you read, so labels are switched off entirely. */
export const LABEL_LAYERS = ["place-label", "road-label"] as const;

export const GROUND = "#0A0A0A";
export const ROAD_MAJOR = "#6E6E6E";
